import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "input", "submit"]
  static values  = { confirmation: String }

  // Pas d'haptique ici : ouvrir la dialog n'engage à rien et reste annulable.
  // `warning` est porté par le bouton de soumission (data-haptic dans la vue),
  // seul moment où l'action devient irréversible.
  open(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.submitTarget.disabled = true
    this.dialogTarget.showModal()
  }

  close(event) {
    event.preventDefault()
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target.tagName === "DIALOG") event.target.close()
  }

  check() {
    const cursor = this.inputTarget.selectionStart
    this.inputTarget.value = this.inputTarget.value.toUpperCase()
    this.inputTarget.setSelectionRange(cursor, cursor)
    this.submitTarget.disabled = this.inputTarget.value !== this.confirmationValue
  }
}
